module.exports = __webpack_public_path__ + "img/page-13.f4f61237.jpg";